/** Limits progress callbacks to meaningful steps (pure). */
export function throttleProgress(
  report: (fraction: number) => void,
  step = 0.01,
): (fraction: number) => void {
  let last = -Infinity;
  return (fraction) => {
    const p = Math.min(1, Math.max(0, fraction));
    if (p === 1 ? last !== 1 : p - last >= step) {
      last = p;
      report(p);
    }
  };
}
